import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useBalanceSheet } from '@/contexts/BalanceSheetContext';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return 'Rp.\u00a00';
  const hasFraction = Number(amount) % 1 !== 0;
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: hasFraction ? 2 : 0,
  }).format(amount).replace('Rp', 'Rp.');
};

/**
 * GlobalBalanceBanner — a sticky red strip that renders on EVERY page when the
 * dashboard's balance sheet is detected as unbalanced. Hidden when balanced or
 * when no status has been published yet (e.g., first load before visiting Dashboard).
 */
const GlobalBalanceBanner = () => {
  const { isBalanced, difference, updatedAt } = useBalanceSheet();

  // Only show when explicitly unbalanced. `null` (never computed yet) hides the banner.
  if (isBalanced !== false) return null;

  return (
    <div
      role="alert"
      data-testid="global-balance-banner"
      className="sticky top-0 z-40 w-full bg-red-600 text-white shadow-md border-b-2 border-red-700"
    >
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
        <AlertCircle size={18} className="shrink-0" />
        <div className="flex-1 leading-tight">
          <span className="font-semibold">Balance Sheet tidak seimbang.</span>{' '}
          <span className="opacity-90">
            Selisih: <span className="font-mono font-semibold">{formatCurrency(difference)}</span>
          </span>
          {updatedAt && (
            <span className="opacity-70 ml-2 hidden sm:inline">
              (terakhir dicek: {new Date(updatedAt).toLocaleTimeString('id-ID')})
            </span>
          )}
        </div>
        <a
          href="/dashboard"
          className="px-3 py-1 rounded bg-white text-red-700 font-semibold text-xs hover:bg-red-50 transition-colors whitespace-nowrap"
          data-testid="global-balance-banner-link"
        >
          Buka Dashboard
        </a>
      </div>
    </div>
  );
};

export default GlobalBalanceBanner;
